import { CollegeSlider, TagList } from "../components/home";
import { registerWidget, DME, DMEData, generalSettings } from "dmeditor";
import { FacebookProvider, Page } from "react-facebook";

export interface FacebookEnitity {
  url: string;
  height?: number;
}

export const Facebook = (props: DME.WidgetRenderProps<FacebookEnitity>) => {
  const {
    blockNode: { data },
  } = props;

  return (
    <div className="px-6">
      <div className="flex flex-col gap-y-6">
        {data.url && (
          <FacebookProvider appId="1074731809831473">
            <Page
              href="https://www.facebook.com/tsscollegebound"
              width={500}
              height={data.height || 600}
              tabs="timeline"
            />
          </FacebookProvider>
        )}
      </div>
    </div>
  );
};
